export default __webpack_public_path__ + "static/media/analyse-positionnement.23d0517d.svg";